/**
 * Приводит аргумент к массиву
 * Если аргумент уже в виде массива - то оставит как есть
 * @example
 * toArray(123); // [123]
 * toArray([123]); //[123]
 * */
export const toArray = <T>(arg: T | T[]): T[] => {
  return Array.isArray(arg) ? arg : [arg];
};
